import React from 'react';
import LandingHeader from './LandingHeader';
import Banner from './Banner';
import KeyPillars from './sections/KeyPillars/KeyPillars';
import Footer from './sections/Footer/Footer';
import './LandingPage.css';
import { Helmet } from 'react-helmet';

const LandingPage = ({ history, location }) => {
  return (
    <>
    <Helmet>
      <title>OMICON</title>
    </Helmet>
    <div className="landing-page">
      <LandingHeader history={history} />
      <Banner history={history} location={location} />
      <KeyPillars />
      <Footer />
    </div>
    </>
  );
};

export default LandingPage;